function BenefitCard(props) {
    const cardData = props.cardData;
    
    if(cardData.left === true){
        return (
            <div className="benefitCard">
                <div className="benefitCardLeft">
                    <div className="benefitCardLeftContainer">
                        <h1 className="benefitCardTitle">{cardData.title}</h1>
                        <ul className="benefitCardList">
                            {cardData.details.map((detail, index) => {
                                return (
                                    <li key={index} className="benefitCardListItem">
                                        {detail}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
                <div className="benefitCardRight">
                    <div className="benefitCardRightContainer">
                        <img className="benefitCardImage" src={cardData.image} alt={cardData.title}/>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="benefitCard">
                <div className="benefitCardRight">
                    <div className="benefitCardRightContainer">
                        <img className="benefitCardImage" src={cardData.image} alt={cardData.title}/>
                    </div>
                </div>
                <div className="benefitCardLeft">
                    <div className="benefitCardLeftContainer">
                        <h1 className="benefitCardTitle">{cardData.title}</h1>
                        <ul className="benefitCardList">
                            {cardData.details.map((detail, index) => {
                                return (
                                    <li key={index} className="benefitCardListItem">
                                        {detail}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}
export default BenefitCard;